
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="flex-grow flex items-center justify-center bg-gray-50 py-12">
      <div className="text-center max-w-md px-4">
        <h1 className="text-6xl font-bold text-propertylk-darkblue mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-6">Oops! We can't find the page you're looking for.</p>
        <p className="text-gray-500 mb-8">
          The page you requested may have been moved or doesn't exist. 
          Let's get you back on track.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild className="bg-propertylk-blue hover:bg-propertylk-darkblue">
            <Link to="/">
              Return to Home
            </Link>
          </Button>
          <Button variant="outline" asChild className="border-propertylk-blue text-propertylk-blue hover:bg-propertylk-blue hover:text-white">
            <Link to="/properties">
              Browse Properties
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
